(() => {
  const init = () => {
    const root = document.querySelector('.section-adaptive');
    if (!root) return;

    const variantRadios = root.querySelector('variant-radios');
    const stickyButton = document.querySelector(
      '.sticky-quick-add #btn-add, .picky-theme-atc-wrapper #btn-add'
    );
    if (!variantRadios || !stickyButton) return;

    const variantDataScript = variantRadios.querySelector(
      'script[type="application/json"]'
    );
    let variantData = [];
    try {
      variantData = JSON.parse(variantDataScript?.textContent || '[]');
    } catch (err) {
      return;
    }
    if (!Array.isArray(variantData) || variantData.length === 0) return;

    const readGlobal = name => {
      try {
        const value = new Function(
          `return typeof ${name} !== 'undefined' ? ${name} : undefined;`
        )();
        return typeof value === 'string' && value ? value : null;
      } catch (err) {
        return null;
      }
    };

    const addToCartText = readGlobal('addToCartBtnText') || 'Add to cart';
    const backInStockText =
      readGlobal('backInStockBtnText') || 'Notify when available';
    const preOrderText =
      readGlobal('preOrderBtnText') ||
      (typeof window.preOrderBtnText === 'string'
        ? window.preOrderBtnText
        : 'Pre-order Now');
    const variantsPreOrderInsteadOos =
      window.variantsPreOrderInsteadOos === true ||
      document.querySelector('[data-variants-pre-order-instead-oos="true"]') !=
        null;
    const productBadgePreOrder = window.productBadgePreOrder === true;

    const formatPrice = cents => {
      if (typeof window.formatMoney === 'function') {
        return window.formatMoney(cents);
      }
      const value = Number(cents) / 100;
      return Number.isNaN(value) ? '' : `$${value.toFixed(2)}`;
    };

    const getCheckedOptions = () => {
      const fieldsets = Array.from(variantRadios.querySelectorAll('fieldset'));
      const options = [];
      for (const fieldset of fieldsets) {
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        if (!checked) return null;
        options.push(checked.value);
      }
      return options;
    };

    const findVariant = () => {
      const options = getCheckedOptions();
      if (!options) return null;
      return (
        variantData.find(variant =>
          variant.options.every((value, index) => options[index] === value)
        ) || null
      );
    };

    const isVariantPurchaseAvailable = variant => {
      if (!variant) return false;
      const radio = variantRadios.querySelector(
        `input[data-variant-id="${variant.id}"]`
      );
      const radioAvailable = radio?.dataset?.available;
      if (radioAvailable !== undefined) return radioAvailable === 'true';
      return !!variant.available;
    };

    const isVariantQtyPreOrder = variant => {
      if (!variant) return false;
      const radio = variantRadios.querySelector(
        `input[data-variant-id="${variant.id}"]`
      );
      if (!radio) return false;
      if (radio.dataset.preOrder !== undefined) {
        return radio.dataset.preOrder === 'true';
      }
      if (!variantsPreOrderInsteadOos) return false;
      if (radio.dataset.inventoryPolicy !== 'continue') return false;
      const qty = Number(radio.dataset.inventoryQuantity);
      return Number.isFinite(qty) && qty <= 0;
    };

    const renderSticky = variant => {
      if (!variant) return;

      // Preserve the `.white` class added on scroll near footer
      const hasWhite = stickyButton.classList.contains('white');

      const variantAvailable = isVariantPurchaseAvailable(variant);
      const qtyPreOrder = isVariantQtyPreOrder(variant);
      const treatAsPreOrder = qtyPreOrder || productBadgePreOrder;

      if (!variantAvailable && !qtyPreOrder) {
        stickyButton.classList.add('notify');
        stickyButton.classList.remove('disabled');
        stickyButton.textContent = backInStockText;
        if (hasWhite) stickyButton.classList.add('white');
        return;
      }

      stickyButton.classList.remove('notify', 'disabled');

      const priceLabel = formatPrice(variant.price);
      const hasCompare =
        variant.compare_at_price && variant.compare_at_price > variant.price;
      const compareLabel = hasCompare
        ? formatPrice(variant.compare_at_price)
        : '';

      // Preserve a single text-space between the "/" and the compare price
      // so the rendered output matches the Liquid template (which gets the
      // space from source whitespace between the inner <span>s). The space
      // before "/" is provided by `.equipment.price`'s `display: inline-flex;
      // gap: 6px` rule in main-product-adaptive.css.
      const compareHtml = hasCompare
        ? `<span style="font-weight: 500;" class="price-old-btn"><span>/</span> <span class="old-switch-price">${compareLabel}</span></span>`
        : '';

      const ctaText = treatAsPreOrder ? preOrderText : addToCartText;

      stickyButton.innerHTML =
        `<span class="ripple-effect js-ripple"><span class="ripple-effect__circle"></span></span>` +
        `<p class="btn__text">${ctaText}</p>` +
        `<span class="equipment price" style="margin-left: 4px"> — <span>${priceLabel}</span>${compareHtml}</span>` +
        `<div class="loading-overlay__spinner hidden"></div>`;
      if (hasWhite) stickyButton.classList.add('white');
    };

    // Re-render strictly from variant JSON for the variant that is currently
    // checked. Used both synchronously on change and as delayed safety nets
    // that win against the legacy 1000ms timeout in `sticky-quick-add.liquid`
    // and against `toggleAddButton` from `global.js` (both of which can either
    // (a) leave the button in a price-with-OOS state because they fall into
    // the wrong branch on the adaptive template (`data-template="product.adaptive"`
    // doesn't match `body[data-template="product"]`), or (b) re-render the
    // button without the compare-at price because the DOM price section may
    // not have refreshed yet from `renderProductInfo`).
    const reapply = () => {
      const variant = findVariant();
      if (variant) renderSticky(variant);
    };

    // Schedule re-renders that consistently win against the legacy +1000ms
    // timeout (sticky-quick-add.liquid) and any late mutations from
    // `toggleAddButton` after `renderProductInfo` resolves on slow networks.
    // Each call adds its own timeouts; rapid clicks just produce a few extra
    // cheap re-renders that all read the currently checked variant.
    const scheduleSafetyNets = () => {
      setTimeout(reapply, 1100);
      setTimeout(reapply, 1700);
    };

    const handleChange = event => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (target.type !== 'radio') return;
      if (!variantRadios.contains(target)) return;

      reapply();
      scheduleSafetyNets();
    };

    variantRadios.addEventListener('change', handleChange);

    // Also listen to the form-level change that `updateVariantInput` dispatches;
    // some legacy code paths can mutate the sticky button after we render, so
    // re-apply as a safety net on every form change as well.
    const form = document.querySelector(
      `#product-form-${variantRadios.dataset.section}, form[data-type="add-to-cart-form"]`
    );
    if (form) {
      form.addEventListener('change', scheduleSafetyNets);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
